import { render, staticRenderFns } from "./SendLog.vue?vue&type=template&id=d64878fc"
import script from "./SendLog.vue?vue&type=script&lang=js"
export * from "./SendLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports